import React, { FunctionComponent, memo } from "react";
import classNames from "classnames";

import { IProps } from "./track.types";
import "./track.scss";

/**
 * Track
 * @param props.source
 * @param props.target
 * @param props.getTargetProps
 * @param props.disabled
 */
const Track: FunctionComponent<IProps> = ({ source, target, getTrackProps, disabled }) => {
    const trackRangeClassnames = classNames("metric-slider__rail__tracks__range", {
        "metric-slider__rail__tracks__range--disabled": disabled,
    });
    return (
        <div
            className={trackRangeClassnames}
            style={{
                left: `${source.percent}%`,
                width: `${target.percent - source.percent}%`,
            }}
            {...getTrackProps()}
        />
    );
};

export default memo(Track);
